import { useSuspenseQuery } from "@tanstack/react-query";

import { useEnableGcpFakeSystemEngine } from "featureFlags/hooks/useEnableGcpFakeSystemEngine";
import { ReactQueryKeysAccount } from "services/queryKeys";

import { getDatabaseTables } from "./getDatabaseTables";

export type Table = {
  tableName: string;
  tableType: string;
  tableOwner: string;
  created: string;
  lastAltered: string;
};

export const useTableNames = ({
  database,
  includeTableTypes,
}: {
  database: string;
  includeTableTypes?: string[];
}): Table[] => {
  const endpoint = useEnableGcpFakeSystemEngine();
  const { data } = useSuspenseQuery<Table[], Error>({
    queryKey: [ReactQueryKeysAccount.tableNames, database],
    queryFn: async () => {
      const tables = await getDatabaseTables(database, {
        includeTableTypes,
        endpoint,
      });
      return tables;
    },
  });
  return data || [];
};
